<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="标题">
                    <el-input v-model="query.keyword" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/demoSite/add'">添加</el-button>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="" label="图片" width="100">
                        <template slot-scope="scope">
                            <el-image style="height: 40px" fit="contain" v-if="scope.row.thumb" class="ya-img-table" :src="scope.row.thumb"
                                      :preview-src-list="[scope.row.thumb]" title="点击查看大图" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" width="80"></el-table-column>
                    <el-table-column prop="status_desc" label="状态" width="80"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/demoSite/edit'">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/demoSite/del'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :current-page="query.page"
                    :page-size="query.list_rows"
                    layout="total, prev, pager, next, jumper"
                    :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
        <edit ref="edit" @fetch-data="refresh"></edit>
    </div>
</template>

<script>
import { demoSiteList, demoSiteDel} from '@/api/education';
import Edit from './edit.vue';
// import Add from './Add.vue';

export default {
    components: {
        /*编辑组件*/
        Edit,
        // Add
    },
    data() {
        return {
            /*是否加载完成*/
            loading: true,
            /*列表数据*/
            tableData: [],
            /*横向表单数据模型*/
            form: {
                become: '0'
            },
            /*是否打开添加弹窗*/
            open_add: false,
            /*是否打开编辑弹窗*/
            open_edit: false,
            /*当前编辑的对象*/
            userModel: {},
            total: 0,
            query: {
                keyword: '',
                page: 1,
                list_rows: 10,
            },
        };
    },
    created() {
        /*获取列表*/
        this.getTableList();
    },
    methods: {
        //选择第几页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getTableList();
        },
        //每页多少条
        handleSizeChange(val) {
            this.query.list_rows = val;
            this.getTableList();
        },
        /*获取列表*/
        getTableList() {
            this.loading = true;
            demoSiteList(this.query).then((result)=>{
                console.log(result);
                this.loading = false;
                this.tableData = result.data.data;
                this.total = result.data.total
            })
        },
        // 刷新
        refresh() {
            this.query = this.$options.data().query
            this.getTableList()
        },
        // 查询
        search() {
            this.query.page = 1
            this.getTableList()
        },
        // 添加
        handleAdd(){
            this.$refs['edit'].showDialog()
        },
        // 编辑
        handleEdit(row) {
            this.$refs['edit'].showDialog(row)
        },
        // 删除
        handleDelete(row) {
            if (row.id) {
                this.$confirm('确定要删除当前项吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    demoSiteDel({id: row.id}).then((result)=>{
                        this.$message({message: result.msg, type: 'success'});
                        this.getTableList()
                    })
                }).catch(() => {

                });
            }
        },
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/demosite/index.vue